import $ from 'jquery';
import { TweenMax, TimelineMax, Power3 } from 'gsap';
import Helpers from '../helpers/util';
import Hammer from 'hammerjs';

const trackToastDismiss = (toastID) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'custom.event.toast_dismiss',
		'custom.event.toast_id': toastID,
	});
};

const trackToastClick = (toastUrl) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'custom.event.toast_click',
		'custom.event.toast_url': toastUrl,
	});
};

const trackNotificationOpen = (sidebarName) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: `custom.event.${sidebarName}_open`,
		'custom.event.sidebar_name': sidebarName,
	});
};

const trackNotificationClose = (sidebarName) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: `custom.event.${sidebarName}_close`,
		'custom.event.sidebar_name': sidebarName,
	});
};

class Notifications {
	constructor(el) {
		// Elements
		this.$el = $(el);

		this.selectors = {
			section: '.notification-list__section',
			heading: '.notification-list__heading',
			itemsCont: '.notification-list__items',
			toasterHome: '.notification-toaster',
			navBadge: '.js-notification-badge',
			closeButton: '.toaster__close',
			toasterLink: '.toaster__link',
		};

		this.$section = this.$el.find(this.selectors.section);
		this.$navBadge = $(this.selectors.navBadge);
		this.isPopup = false;
		this.classes = {
			isVisible: 'is-visible',
			isRead: 'is-read',
			isTransition: 'is-transition',
			isUpdating: 'is-updating',
		};

		this.data = {};
		this.filterLabels = [
			{ label: 'Today', key: 'today' },
			{ label: 'Recent', key: 'recent' },
			{ label: 'Older', key: 'older' },
		];
		this.filteredItems = [];
		this.oldNumber = -1;
		this.getAllItems();
	}

	getAllItems() {
		// const APIBASEURL = '/api/notifications';

		const localAPI = '/data/notifications.json';
		const productionAPI = '/api/notifications';
		const APIBASEURL = Helpers.urlExists(productionAPI)
			? productionAPI
			: localAPI;

		fetch(APIBASEURL)
			.then((res) => res.json())
			.then((data) => {
				this.data = data;
				this.updateBadgeNav();
				this.createListPanel();
				this.createToasterHome();
				this.attachEvents();
			});
	}

	updateBadgeNav() {
		if (this.data) {
			if (this.data.unread > 0) {
				this.$navBadge
					.addClass(this.classes.isVisible)
					.addClass(this.classes.isTransition);
				this.$navBadge.text(this.data.unread);
			} else {
				this.$navBadge
					.removeClass(this.classes.isVisible)
					.removeClass(this.classes.isTransition);
				this.$navBadge.text('');
			}

			this.nrUpdated = this.data.unread;
		}
	}

	createToaster(item, cxt) {
		const isHome = cxt === 'is-home';
		const type = item.type === 'alert' ? 'high' : 'low';
		const nodeEntity =
			item.entity === 'node' ? 'data-lightbox="leavesite"' : '';
		const href = item.link ? `href="${item.link}"` : 'data-no-cta';
		const typeAnimationCls = isHome ? `is-${type}-animated` : '';
		const statusCls = item.unread === false ? 'is-read' : '';
		const noCtaClass = !item.link ? 'no-cta' : '';

		const _temp = `<div class="toaster toaster--${type} ${typeAnimationCls} ${statusCls} ${noCtaClass}" data-id="${
			item.id
		}" data-entity="${item.entity}">
            <a class="toaster__link" ${href} ${nodeEntity}>
                <div class="toaster__icon">
                    <span class="icon icon-${type}-priority"></span>
                </div>
            
                <div class="toaster__info">
                    <div class="toaster__title">
                        ${item.title}
                    </div>

                    ${
						item.last_updated
							? `
                    <div class="toaster__update">
                        Reported on ${item.last_updated}
                    </div>
                    `
							: ''
					}

                    ${
						!isHome
							? `
                    <div class="toaster__date">
                        <span class="icon icon-clock"></span>
                        ${item.date} ago
                    </div>
                    `
							: ''
					}

                    ${
						isHome && item.link
							? `
					<div class="toaster__cta">
						${
							item.link_text ? item.link_text : 'Find out more'
						} <span class="icon icon-chevron-right"></span>
                    </div>
                    `
							: ''
					}
                </div>

                ${
					item.link && !isHome
						? `
                <div class="toaster__arrow">
                    <span class="icon icon-chevron-right"></span>
                </div>
                `
						: ''
				}
            </a>
            ${
				isHome
					? `
            <button class="toaster__close"><span class="icon icon-close"></span></button>
            `
					: ''
			}
        </div>`;

		return _temp;
	}

	createListPanel() {
		this.filteredItems = this.getFilters(this.data);

		this.filteredItems.forEach((category) => {
			// Array destructuring
			const [labelCategory, itemsCategory] = category;

			// clone section HTML foreach category
			const $sectionClone = this.$section.clone();

			// populate it
			$sectionClone.find(this.selectors.heading).text(labelCategory);
			$sectionClone.appendTo(this.$el);

			// loop items foreach category
			itemsCategory.forEach((item) => {
				// create list notification including popup
				let toaster = this.createToaster(item);
				$sectionClone.find(this.selectors.itemsCont).append(toaster);
			});
		});
	}

	setHeightToasterWrap() {
		const toasterH = $(this.selectors.toasterHome)
			.find('.toaster')
			.height();
		$(this.selectors.toasterHome).height(toasterH);
	}

	isEmpty(obj) {
		for (var key in obj) {
			if (obj.hasOwnProperty(key)) {
				return false;
			}
		}
		return true;
	}

	createToasterHome() {
		if (!this.isEmpty(this.data.toast)) {
			let toaster = this.createToaster(this.data.toast, 'is-home');
			$.when($(this.selectors.toasterHome).append(toaster)).then(() => {
				this.setHeightToasterWrap();
			});
		}
	}

	getFilters(data) {
		const filteredItems = [];

		this.filterLabels.forEach((filter) => {
			// Create array with all the options with that key
			Object.entries(data).map((x) => {
				if (x[0] === filter.key) {
					filteredItems.push(x);
				}
			});
		});

		return filteredItems;
	}

	checkUnreadItems() {
		// mark as read the ones without link
		const $allItemsNoCta = $('.notification-list').find('.no-cta');
		const arrayUnreadCta = [];

		$allItemsNoCta.each((e, item) => {
			if (!$(item).hasClass(this.classes.isRead)) {
				$(item).addClass(this.classes.isTransition);

				setTimeout(() => {
					$(item)
						.addClass(this.classes.isRead)
						.removeClass(this.classes.isTransition);
				}, 600);

				arrayUnreadCta.push(item);
			}
		});

		this.markAsRead(arrayUnreadCta);
	}

	markAsRead(arrayUnread) {
		// ajax call
		return new Promise((resolve) => {
			this.dataItemRead = [];

			arrayUnread.forEach((item) => {
				const entity = $(item).data('entity');
				const id = $(item).data('id');
				const data = {
					entity: entity,
					id: id,
				};
				this.dataItemRead.push(data);
			});

			// Fetch token
			fetch('/session/token')
				.then((res) => res.text())
				.then((data) => {
					this.token = data;

					$.ajax({
						url: '/api/notifications/read',
						data: JSON.stringify(this.dataItemRead),
						type: 'POST',
						dataType: 'json',
						contentType: 'application/json',
						headers: {
							'X-CSRF-Token': this.token,
						},
						success: () => {
							resolve();
						},
						error: () => {
							resolve();
						},
					});
				});

			//decrease number read items (for badge)
			const nrRead = arrayUnread.length;
			this.nrUpdated = this.nrUpdated - nrRead;
		});
	}

	changeToastStatus(item) {
		if (!$(item).hasClass(this.classes.isRead)) {
			$(item).addClass(this.classes.isTransition);

			setTimeout(() => {
				$(item)
					.addClass(this.classes.isRead)
					.removeClass(this.classes.isTransition);
			}, 600);
		}
	}

	updateBadgeAfterRead() {
		// Decrease number of notifications

		if (this.nrUpdated > 0) {
			this.$navBadge.text(this.nrUpdated);

			if (this.oldNumber !== this.nrUpdated) {
				//animation badge only if number is different
				this.$navBadge.toggleClass(this.classes.isUpdating);
				this.oldNumber = this.nrUpdated;
			}
		} else {
			// no badge needed
			this.$navBadge.removeClass(this.classes.isVisible);
		}
	}

	removeItem(el) {
		const tl = new TimelineMax();

		tl.to(el, 0.1, {
			autoAlpha: 0,
			onComplete: () => {
				let arrayUnreadItem = [el.get(0)];

				this.markAsRead(arrayUnreadItem).then(() => {
					el.remove();
				});
			},
		});

		tl.to(this.selectors.toasterHome, 0.6, {
			height: 0,
			ease: Power3.easeInOut,
		});
	}

	dragToaster() {
		let currXPos = 0;
		let outOfScreen = false;

		const $toasterHome = $(this.selectors.toasterHome).find('.toaster');
		const hammertime = new Hammer($toasterHome.get(0));
		const ww = Math.max(
			document.documentElement.clientWidth,
			window.innerWidth || 0
		);

		hammertime.on('panleft panright', (ev) => {
			// const elToRemove = $(ev.target).parents('.toaster');

			currXPos = ev.deltaX;
			let normalizedDragDistance = Math.abs(currXPos) / ww;

			TweenMax.set(this.selectors.toasterHome, {
				x: ev.deltaX,
				opacity: 1 - Math.pow(normalizedDragDistance, 0.7),
			});
		});

		$toasterHome.on('touchend', (ev) => {
			const elToRemove = $(ev.target).parents('.toaster');
			let dragToX = 0;
			let opacityCont = 0;

			const tl = new TimelineMax({
				onComplete: () => {
					if (outOfScreen) {
						this.removeItem(elToRemove);
						TweenMax.set(this.selectors.toasterHome, {
							clearProps: 'x',
						});
					}
				},
			});

			if (currXPos > ww / 3) {
				dragToX = '100%';
				outOfScreen = true;
				opacityCont = 0;
			} else {
				dragToX = 0;
				opacityCont = 1;
			}

			if (currXPos < -(ww / 3)) {
				dragToX = '-100%';
				outOfScreen = true;
				opacityCont = 0;
			} else {
				dragToX = 0;
				opacityCont = 1;
			}

			tl.to(this.selectors.toasterHome, 0.5, {
				x: dragToX,
				opacity: opacityCont,
				ease: Power3.easeInOut,
			});
		});
	}

	attachEvents() {
		if (window.Modernizr.touch) {
			this.dragToaster();
		}

		$(this.selectors.closeButton).on('click', (evt) => {
			evt.preventDefault();
			const elToRemove = $(evt.target).parents('.toaster');
			const toastId = elToRemove.data('id');
			console.log(toastId);
			trackToastDismiss(toastId);

			this.removeItem(elToRemove);
		});

		// `Mark as read` clicked items
		$(this.selectors.toasterLink)
			.not('[data-no-cta]')
			.on('click', (evt) => {
				evt.preventDefault();

				const $link = $(evt.currentTarget);
				const $external = $link.attr('data-lightbox') === 'leavesite';
				const href = $link.attr('href');
				const $itemClicked = $link.parents('.toaster');
				let arrayUnreadItem = [$itemClicked.get(0)];

				// GTM track
				trackToastClick(href);

				// for outer use
				this.$itemClicked = $itemClicked;
				this.arrayUnreadItem = arrayUnreadItem;

				if ($external) {
					Helpers.pubsub.publish('externalLink', evt);
				} else {
					this.markAsRead(arrayUnreadItem).then(() => {
						location.href = href;
					});
				}
			});

		//Mark as read when click btn inside lightbox
		$('.js-external-link').on('click', (evt) => {
			if ($(evt.currentTarget).hasClass('js-external-link--toaster')) {
				this.markAsRead(this.arrayUnreadItem).then(() => {
					this.changeToastStatus(this.$itemClicked);
				});
			}
		});

		Helpers.pubsub.subscribe('onSidebarClose', (name, e) => {
			if (e.hasClass('js-sidebar-notifications')) {
				trackNotificationClose('notifications');

				setTimeout(() => {
					this.updateBadgeAfterRead();
				}, 400);
			}
		});

		Helpers.pubsub.subscribe('onSidebarShow', (name, e) => {
			const nameSidebar = e.data('sidebar');
			if (e.hasClass('nav-notifications') && nameSidebar) {
				this.checkUnreadItems();
				trackNotificationOpen(nameSidebar);
			}
		});

		Helpers.pubsub.subscribe('onWindowResize', () => {
			this.setHeightToasterWrap();
		});
	}
}

const _init = () => {
	// Elements
	let $el = $('.notification-list');
	if ($el.length) {
		new Notifications($el);
	}
};

_init();
